import React from "react";

export default function AdminDArticlesReception() {
  return <div>AdminDArticlesReception</div>;
}
